<script setup>
import TransitionDropdown from '@/components/shared/transitions/TransitionDropdown.vue'

//Emits and props
defineProps({
  alignment: {
    type: String,
    default: '',
  },
  isVisible: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <TransitionDropdown>
    <div
      v-if="isVisible"
      :class="{
        [$style.dropdown]: true,
        [$style[alignment]]: !!alignment,
      }"
    >
      <slot />
    </div>
  </TransitionDropdown>
</template>

<style module lang="scss">
.dropdown {
  position: absolute;
  z-index: 9999;
  background: var(--bg-page-element);
  border-radius: var(--border-radius-m);
  box-shadow: var(--box-shadow);
}
.left {
  left: 0;
}
.right {
  right: 0;
}
.center {
  left: 50%;
  transform: translateX(-50%);
}
</style>
